import { Link } from "react-router-dom";
import { Reveal, Marquee } from "../components/Reveal";
import { ASSETS, IMG } from "../lib/assets";

export default function Story() {
  return (
    <main data-testid="story-page">
      <section className="px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto pt-20 md:pt-32 pb-16 md:pb-24 text-center">
        <Reveal>
          <p className="vv-overline text-vv-muted mb-6">Beyond the Ordinary — Estd. 2024, Designed in India</p>
          <img src="/logo.png" alt="Velour & Vane" className="w-full max-w-lg mx-auto mb-8" />
          <p className="text-vv-muted mt-8 max-w-xl mx-auto font-light leading-relaxed">
            Timeless. Refined. Yours. A contemporary Indian house built on European restraint — considered design, modern silhouettes, and everyday versatility.
          </p>
        </Reveal>
      </section>

      <Marquee dark items={["Considered Design", "240 GSM Heavyweight", "Understated Expression", "Modern Essentials"]} />

      <section className="px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto py-20 md:py-32 grid md:grid-cols-2 gap-12 lg:gap-24 items-center">
        <Reveal>
          <div className="overflow-hidden">
            <img src={ASSETS.boardBrand} alt="The Velour & Vane identity" className="w-full aspect-[4/3] object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="vv-overline text-vv-muted mb-6">The Philosophy</p>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-tight">BUILT ON SIMPLICITY.</h2>
          <p className="text-vv-muted mt-8 leading-relaxed font-light">
            We create modern wardrobe essentials with an emphasis on fit, texture, detail, and understated expression. Every piece begins as a question: will this still matter in five years? If the answer is no, it never leaves the atelier.
          </p>
          <p className="text-vv-muted mt-4 leading-relaxed font-light">
            Heavyweight 240 GSM cottons, rigid denims, muted earth palettes — clothing that disappears into your life and elevates it quietly.
          </p>
        </Reveal>
      </section>

      <section className="grid md:grid-cols-3 gap-1">
        {[ASSETS.boardIvory, ASSETS.boardMountain, ASSETS.boardTees].map((src, i) => (
          <Reveal key={src} delay={i * 0.08}>
            <div className="overflow-hidden aspect-[4/5]">
              <img src={src} alt="" loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1500ms]" />
            </div>
          </Reveal>
        ))}
      </section>

      <section id="shipping" className="px-4 sm:px-8 lg:px-16 max-w-4xl mx-auto py-20 md:py-32 space-y-16">
        {[
          ["Shipping Policy", "Orders are dispatched within 24–48 hours, Monday to Saturday. Delivery takes 3–6 working days across India. Shipping is free on orders above ₹1,999; a flat ₹99 applies below that. Cash on Delivery is available at most PIN codes."],
          ["Returns & Refunds", "Not right? Return or exchange within 7 days of delivery, unworn with tags attached. Refunds are processed to the original payment method within 5–7 working days of pickup."],
          ["FAQs", "Sizing: our tees are cut oversized — take your usual size for the intended drape, or size down for a regular fit. Denim: rigid fabric breaks in after a few wears. Care: machine wash cold, inside out, line dry in shade."],
          ["Privacy Policy", "We collect only what we need to fulfil your order — name, contact, and delivery address. We never sell your data. Newsletter emails are occasional and you can unsubscribe anytime."],
          ["Terms & Conditions", "All prices are in INR and inclusive of taxes. Product colours may vary slightly from photographs due to lighting. Velour & Vane reserves the right to update pricing and availability without notice."],
          ["Contact", "Write to us at care@velourandvane.in — we reply within one working day."],
        ].map(([title, body]) => (
          <Reveal key={title}>
            <div id={title === "Contact" ? "contact" : title === "FAQs" ? "faqs" : title === "Returns & Refunds" ? "returns" : title === "Privacy Policy" ? "privacy" : title === "Terms & Conditions" ? "terms" : undefined}>
              <h2 className="font-display text-3xl tracking-tight mb-4">{title}</h2>
              <p className="text-vv-muted leading-relaxed font-light">{body}</p>
            </div>
          </Reveal>
        ))}
        <Reveal className="text-center pt-8">
          <Link data-testid="story-shop-button" to="/shop" className="vv-btn-dark">Shop the Collection</Link>
        </Reveal>
      </section>
    </main>
  );
}
